export const TYPES_LIST = ['Repeat'];

export const REPEAT_PERIODS_LIST = ['Quarterly', 'Annually'];

export const REPEAT_STARTTYPES_LIST = ['COE Date'];

export const REPEAT_ENDTYPES_LIST = ['After 1 years', 'After 5 years', 'After 10 years'];

export const TASK_TYPE_LIST = [
  { value: 0, text: 'Repeat'}
];

export const REPEAT_PERIOD_LIST = [
  { value: 0, text: 'Quarterly', description: 'quarterly'},
  { value: 1, text: 'Annually', description: 'annually'}
];

export const REPEAT_START_LIST = [
  { value: 0, text: 'COE Date', description: 'COE date'}
];

export const REPEAT_START_SPECIFIC_LIST = [
  { value: 0, text: 'Purchased Date', description: 'Purchased Date'}
];

export const REPEAT_END_LIST = [
  { value: 0, text: 'After 1 year', description: '1 year after'},
  { value: 1, text: 'After 5 years', description: '5 years after'},
  { value: 2, text: 'After 10 years', description: '10 years after'}
];




// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/maintenance-enums.js